"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

var _reactRouterDom = require("react-router-dom");

var _title = _interopRequireDefault(require("./title"));

var _contact = _interopRequireDefault(require("./contact"));

var _hours = _interopRequireDefault(require("./hours"));

var _map = _interopRequireDefault(require("./map"));

var _medications = _interopRequireDefault(require("./medications"));

var _specialties = _interopRequireDefault(require("./specialties"));

var _facts = _interopRequireDefault(require("./facts"));

var _amenities = _interopRequireDefault(require("./amenities"));

var _loading = _interopRequireDefault(require("../../_common/loading"));

var _selectors = require("../../../redux/locations/selectors");

var _selectors2 = require("../../../redux/attributes/selectors");

var _actions = require("../../../redux/locations/actions");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LocationDetails = function LocationDetails() {
  var history = (0, _reactRouterDom.useHistory)();

  var _useParams = (0, _reactRouterDom.useParams)(),
      locationId = _useParams.locationId;

  var location = (0, _selectors.useLocationDetailsSelector)(locationId);

  var _useState = (0, _react.useState)(!Boolean(location)),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var randomIcon = (0, _selectors2.useAttributeIconSelector)(_attributeIds.default.medicationsAvailable);
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.trackPageView)(locationId));

    if (!location && locationId) {
      dispatch((0, _actions.loadLocation)(locationId, setLoading, function () {
        return history.push('/');
      }));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "h100 bodyFont details-container"
  }, !location || randomIcon.length === 0 || loading ? /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 50
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_title.default, {
    location: location
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex2 details-container-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "details-contact-panel"
  }, /*#__PURE__*/_react.default.createElement(_contact.default, {
    location: location
  })), location && location.description && /*#__PURE__*/_react.default.createElement("div", {
    className: "details-description"
  }, location.description), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex details-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_hours.default, {
    location: location
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1 details-map"
  }, /*#__PURE__*/_react.default.createElement(_map.default, {
    location: location
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex details-green-bg details-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_medications.default, {
    location: location
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex1"
  }, /*#__PURE__*/_react.default.createElement(_specialties.default, {
    location: location
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex details-blue-bg details-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex3 h100"
  }, /*#__PURE__*/_react.default.createElement(_facts.default, {
    location: location
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex2"
  }, /*#__PURE__*/_react.default.createElement(_amenities.default, {
    location: location
  }))))));
};

var _default = LocationDetails;
exports.default = _default;